import Vue from 'vue'
import Router from 'vue-router'
import Booking from './views/Booking.vue'
import MyProfile from './views/MyProfile.vue'

import store from './store'

Vue.use(Router)

store.dispatch('autoLogin')
store.dispatch('autoLoadSite')

export default new Router({
  mode: 'history',
  base: '/',
  linkExactActiveClass: 'active',
  linkActiveClass: '',
  routes: [{
      path: '/:alias',
      name: 'home',
      component: Booking
    },
    {
      path: '/myprofile',
      name: 'myprofile',
      component: MyProfile
    },
    {
      path: '/booking/:booking_id',
      name: 'booking',
      component: Booking
    }
  ]
})